"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAll = void 0;
var spritesCursors_1 = require("@dive/spriteRecyclers/spritesCursors");
var diveTilemap_sidecar_1 = require("@dive/tilemap/diveTilemap-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var voyagePicker_sidecar_1 = require("@voyage/ui-cursors/voyagePicker-sidecar");
var diveMultiplayerCursors_sidecar_1 = require("./diveMultiplayerCursors-sidecar");
function updateAll() {
    var e_1, _a;
    var selectedCrew = voyagePicker_sidecar_1.voyagePicker.get().selectedCrew;
    displayPathForCrew(selectedCrew, 0.75);
    var mpCursors = diveMultiplayerCursors_sidecar_1.diveMultiplayerCursors.getAll();
    try {
        for (var mpCursors_1 = __values(mpCursors), mpCursors_1_1 = mpCursors_1.next(); !mpCursors_1_1.done; mpCursors_1_1 = mpCursors_1.next()) {
            var obj = mpCursors_1_1.value;
            if (obj.isHidden) {
                continue;
            }
            displayPathForCrew(obj.crewSelected, 0.5);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (mpCursors_1_1 && !mpCursors_1_1.done && (_a = mpCursors_1.return)) _a.call(mpCursors_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
exports.updateAll = updateAll;
function displayPathForCrew(obj, alpha) {
    var _a;
    if (!obj) {
        return;
    }
    var path = (_a = obj.pathResult) === null || _a === void 0 ? void 0 : _a.path;
    if (path && path.length > 0) {
        for (var pathIdx = obj.pathIdx; pathIdx < path.length; pathIdx++) {
            var p = path[pathIdx];
            var _b = diveTilemap_sidecar_1.diveTilemap.convertIIJtoXY(p), x = _b.x, y = _b.y;
            var img = spritesCursors_1.spritesCursors.getNext(x, y, sprites_sidecar_1.sprites.diveEffectsIndicatorMoveO[0]);
            if (pathIdx === path.length - 1) {
                spritesCursors_1.spritesCursors.changeImageFrame(img, sprites_sidecar_1.sprites.diveEffectsIndicatorMoveO[0]);
            }
            img.alpha = alpha;
        }
    }
}
